export default __webpack_public_path__ + "static/media/Steven M. Ferguson.7c5042f8.jpg";